/* eslint-disable @typescript-eslint/no-unsafe-call */

/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

export interface WindowSize {
  height: number | string;
  width: number | string;
}
export function changeWindowSize(callbackFunc: any) {
  callbackFunc({ width: window.innerWidth, height: window.innerHeight });
}

export function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = React.useState<WindowSize>({
    width: '100vw',
    height: '100vh',
  });

  React.useEffect(() => {
    const handleResize = () => {
      changeWindowSize(setWindowSize);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
}
